import { render, staticRenderFns } from "./UploadTachographVehicle.vue?vue&type=template&id=4656a39a&"
import script from "./UploadTachographVehicle.vue?vue&type=script&lang=js&"
export * from "./UploadTachographVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports